import React from "react"
import SidePanelLayout from "aldoo-ra/SidePanel"
import ParamOverview from "./ParamOverview"
import ParamBrowser from "./ParamBrowser"
import ParamSync from "./ParamSync"

const ParamIOHome = () => {

  // Custom tab resolver function
  const customTabResolver = (defaultTab, context, pathname) => {
    if (pathname.includes("/admin/paramio/params")) return "params"
    if (pathname.includes("/admin/paramio/sync")) return "sync"
    if (pathname === "/admin/paramio" || pathname === "/admin/paramio/") return "params"
    return undefined
  }

  return (
    <SidePanelLayout
      menuName="AdminParamIOMenu"
      tabs={{
        overview: ParamOverview,
        params: ParamBrowser,
        sync: ParamSync,
      }}
      tabResolver={customTabResolver}
    />
  )
}

export default ParamIOHome